<template>
  <v-app id="app">
    <router-view>
      {{ $store.state.message }}
    </router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},

  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
.v-application--wrap {
  justify-content: center;
  align-items: center;
}
</style>
